import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "exam" }

import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import QuestionGroup from './QuestionGroupComponent.vue'
import QuestionList from './QuestionListComponent.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExamComponent',
  setup(__props) {

const store = useStore()

const confirmSubmit = computed(() => store.state.Exam.confirmSubmit)

const loadData = () => store.dispatch('Exam/loadData')
const finishExam = () => store.dispatch('Exam/finishExam')
const cancelSubmit = () => store.dispatch('Exam/cancelSubmit')

onMounted(() => {
  loadData()
})

return (_ctx: any,_cache: any) => {
  const _component_btn = _resolveComponent("btn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(QuestionGroup, { class: "question-content" }),
    _createVNode(QuestionList, { class: "question-list" }),
    _createVNode(_component_modal, {
      modelValue: confirmSubmit.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((confirmSubmit).value = $event)),
      ref: "modal",
      id: "modal"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_btn, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (cancelSubmit()))
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("キャンセル", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_btn, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (finishExam())),
          type: "danger"
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode("確認", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        })
      ]),
      default: _withCtx(() => [
        _cache[5] || (_cache[5] = _createElementVNode("p", null, "本当に提出してもよろしいですか？※再提出はできません", -1 /* CACHED */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}
}

})